import styled from "styled-components";
import {flexAdaptiveSizeItem} from "../../../../../themes/architecture/css-helpers/flex";

export const VideoSlidesFilterListPreviewTitleDefaultBox = styled.div`
    display: flex;
    align-items: center;
    min-width: 28rem;
    max-width: 82.5%;
    text-transform: uppercase;
    font-size: 1.5rem;
    line-height: normal;
    margin: 0;
    letter-spacing: 0.2rem;
    ${({theme}) => theme.font.presets.bold};

  
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
      min-width: 65%;
      max-width: 100%;
      font-size: 1.2rem;
    }

    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
      ${flexAdaptiveSizeItem}
      min-width: 0;
    }
`;